/**
 * Single-active-video coordinator.
 *
 * When more than one autoplay/looping video is in the viewport at the same
 * time (e.g. a PromoTile + a PLP tile-hover, or a Frame background + a PDP
 * variant video), the browser will happily play them all in parallel — each
 * one streaming bytes from Cloudinary independently.
 *
 * This module listens for `play` events on videos marked with the
 * `data-managed-video` attribute, and pauses any other managed video that's
 * currently playing. Most-recent-play wins.
 *
 * Why opt-in (the attribute): unrelated videos a user explicitly hit play on
 * — Vimeo embeds, hero modal videos, etc. — should not be paused by this.
 */

let initialized = false;

export function initVideoCoordinator() {
  if (initialized || typeof document === 'undefined') return;
  initialized = true;

  // The `play` event does NOT bubble; use capture phase to observe it
  // anywhere in the document.
  document.addEventListener(
    'play',
    (e) => {
      const target = e.target;
      if (!(target instanceof HTMLVideoElement)) return;
      if (!target.hasAttribute('data-managed-video')) return;

      const playing = document.querySelectorAll('video[data-managed-video]');
      playing.forEach((v) => {
        if (v !== target && !v.paused) v.pause();
      });
    },
    true,
  );
}
